"use client";

import { HeroSection } from "@/components/sections/hero";
import { hero } from "@/lib/data/services-threat-analysis";

export function Hero() {
  return (
    <HeroSection
      id={"top"}
      eyebrow={hero.eyebrow}
      title={hero.title}
      titleAccent={hero.titleAccent}
      lede={hero.lede}
      trustLine={hero.trustLine}
      ctaPrimary={hero.ctaPrimary}
      ctaSecondary={hero.ctaSecondary}
      trustIndicators={hero.trustIndicators}
      introBadges={hero.introBadges}
      primaryAccent={hero.primaryAccent}
      secondaryAccent={hero.secondaryAccent}
    />
  );
}
